var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{attrs:{"valueType":"format","format":_vm.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM',"input-class":"inp inp-date w150","type":_vm.type},on:{"change":_vm.change},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }